module.exports = __webpack_public_path__ + "img/cake-9.4681d191.svg";